import TabberSolidContainer from './tabber_solid_container';

const TabberSolid = TabberSolidContainer;
export default TabberSolid;
